import { useMutation, useQueryClient } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { PatchIntegrationCredentialPayload } from '@rossum/api-client/integrationCredentials';
import { api } from '../../../../lib/apiClient';
import { credentialKeys } from './queryKeys';

export const usePatchCredential = (credentialId: ID | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PatchIntegrationCredentialPayload) =>
      credentialId === undefined
        ? Promise.reject(new Error('Cannot patch a credential without an ID.'))
        : api.request(
            endpoints.integrationCredentials.patch(credentialId, payload)
          ),
    onSuccess: credential => {
      queryClient.invalidateQueries({ queryKey: credentialKeys.list() });
      // The user stays on the form after saving, so the detail query has to be
      // refetched - it is not remounted.
      queryClient.invalidateQueries({
        queryKey: credentialKeys.detail(credential.id),
      });
    },
  });
};
